import { render, staticRenderFns } from "./TechFair.vue?vue&type=template&id=3384befc&scoped=true&"
import script from "./TechFair.vue?vue&type=script&lang=js&"
export * from "./TechFair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3384befc",
  null
  
)

export default component.exports